<div [class.alert-validation-popup]="type === 'alertValidation'">
    <ng-container>
        <div class="header">
            <div class="header-content-container">
                <div class="header-main-content">
                    <h1 mat-dialog-title class="text-capitalize sg-modal-title" [ngClass]="subTitle ? 'm-b-10' : 'm-b-2'" *ngIf="title">{{ title }}</h1>
                    <div class="spacer"></div>
                </div>
                <h4 mat-dialog-sub-title class="text-capitalize sg-modal-sub-title m-b-10" *ngIf="subTitle">{{ subTitle }}</h4>
            </div>
        </div>
    </ng-container>
    <div [class.alert-validation-scroll-region]="type === 'alertValidation'">
        <div mat-dialog-content>
            <div class="row align-items-center">
                <div class="p-l-0 pre-wrap">
                    <div class="scrollable-content">
                        <div class="updates-container" *ngIf="type === 'dialog' && htmlContent?.length > 0">
                            <div class="updated-item" *ngFor="let modifiedData of htmlContent">
                                <div class="label"><span class="key">Sequence: </span> <span class="value">{{modifiedData.sequence}}</span></div>
                                <div class="data-list-container"
                                    *ngIf="modifiedData.updatedFunctions && modifiedData.updatedFunctions.length > 0">
                                    <div class="label">Updated functions:</div>
                                    <ul class="data-list">
                                        <li class="data-list-item" *ngFor="let functionName of modifiedData.updatedFunctions">{{ functionName }}</li>
                                    </ul>
                                </div>
                                <div class="data-list-container" *ngIf="modifiedData.deletedFunctions && modifiedData.deletedFunctions.length > 0">
                                    Deleted functions
                                    <ul class="data-list">
                                        <li class="data-list-item" *ngFor="let functionName of modifiedData.deletedFunctions">{{ functionName }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="updates-container" *ngIf="type === 'alertValidation' && htmlContent?.length > 0">
                            <div class="updated-item" *ngFor="let alertData of htmlContent">
                                <div class="label">
                                    <span class="key">Alert: </span> 
                                    <span class="value">{{alertData.name}}</span>
                                </div>
                                <div class="data-list-container" *ngIf="alertData.upperLimitEnabled || alertData.lowerLimitEnabled">
                                    <div class="label">Values:</div>
                                    <ul class="data-list">
                                        <li class="data-list-item" *ngIf="alertData.upperLimitEnabled">Upper Limit: {{ alertData.upperLimit ?? '-' }}, Upper Limit Fix: {{ alertData.upperLimitFix ?? '-' }}</li>
                                        <li class="data-list-item" *ngIf="alertData.lowerLimitEnabled">Lower Limit: {{ alertData.lowerLimit ?? '-' }}, Lower Limit Fix: {{ alertData.lowerLimitFix ?? '-' }}</li>
                                    </ul>
                                </div>
                                <div class="data-list-container" *ngIf="alertData.errors && alertData.errors.length > 0">
                                    <div class="label">Errors:</div>
                                    <ul class="data-list">
                                        <li class="data-list-item" *ngFor="let error of alertData.errors">{{ error }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="updates-container python-run-container" *ngIf="type === 'python_execution' && htmlContent?.length > 0">
                            <div class="updated-item run-item" *ngFor="let runData of htmlContent" [hidden]="!shouldShowPythonRun(runData)">
                                <div class="label">
                                    <span class="key">{{ runData.sectionTitle || ('Python Run ' + ((runData.runIndex || 0) + 1)) }}: </span>
                                    <span class="value" [ngClass]="runData.success ? 'status-success' : 'status-failure'">
                                        {{ runData.success ? 'Success' : 'Failed' }}
                                    </span>
                                </div>
                                <div class="data-list-container">
                                    <div class="label">Static Analysis:</div>
                                    <ul class="data-list" *ngIf="runData.staticIssues?.length; else noStaticIssues">
                                        <li class="data-list-item" *ngFor="let issue of runData.staticIssues">
                                            <span [ngClass]="issue.severity === 'error' ? 'status-failure' : 'heap-high'">
                                                {{ issue.severity | uppercase }}
                                            </span>
                                            : {{ issue.message }}
                                            <span *ngIf="issue.line"> (Line {{ issue.line }})</span>
                                        </li>
                                    </ul>
                                    <ng-template #noStaticIssues>
                                        <div class="label">No static issues found.</div>
                                    </ng-template>
                                </div>
                                <div class="data-list-container" *ngIf="runData.error">
                                    <div class="label">Error:</div>
                                    <pre class="trace-block">{{ runData.error }}</pre>
                                </div>
                                <div class="data-list-container" *ngIf="runData.stack">
                                    <div class="label">Traceback:</div>
                                    <pre class="trace-block">{{ runData.stack }}</pre>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div mat-dialog-actions class="alert-dialog-action-container" [align]="type === 'alertValidation' ? 'center' : 'end'">
            <ng-container *ngIf="type == 'dialog' || type == 'python_execution' || type == 'alertValidation'">
                <button class="text-uppercase btn color-primary" *ngIf="!(type === 'alertValidation')" (click)="onNoClick()">
                    {{ showContinueButton ? 'Cancel' : 'Ok' }}
                </button>
                <button class="text-uppercase btn color-primary confirm-btn" *ngIf="type === 'alertValidation'" (click)="onNoClick()">
                    <div class="btn-text">
                        OKAY
                    </div>
                </button>
                <button *ngIf="showContinueButton" class="text-uppercase btn color-primary" (click)="onContinueClick()">
                    {{ continueBtnText }}
                </button>
            </ng-container>
        </div>
    </div>
</div>
